export const fieldNames = {
  code: {
    // 製造/車台番号
    name: 'code',
    type: 'text',
    label: 'FORKLIFT_COMMON_CODE_LABEL',
    operator: 'ilike',
    queryName: 'code',
    maxLength: 255,
    tabIndexes: [0]
  },
  maximumLoad: {
  // 最大荷重（ｋｇ）
    label: 'FORKLIFT_COMMON_MAXIMUMLOAD_LABEL',
    name: 'maximumLoad',
    type: 'number',
    tabIndexes: [1, 2]
  },
  vehicleWeight: {
  // 車両重量（ｋｇ）
    label: 'FORKLIFT_COMMON_VEHICLEWEIGHT_LABEL',
    name: 'vehicleWeight',
    type: 'number',
    tabIndexes: [3, 4]
  },
  maximumLiftHeight: {
  // 最大揚高（ｍｍ）
    label: 'FORKLIFT_COMMON_MAXIMUMLIFTHEIGHT_LABEL',
    name: 'maximumLiftHeight',
    type: 'number',
    tabIndexes: [5, 6]
  },
  clawLength: {
  // ツメ長さ（ｍｍ）
    label: 'FORKLIFT_COMMON_CLAWLENGTH_LABEL',
    name: 'clawLength',
    type: 'number',
    tabIndexes: [7, 8]
  }
}
